module.exports = __webpack_public_path__ + "static/media/mercadopago.6a742597.png";